import {
    DXP_MANUFACTURER_GET,
    DXP_MANUFACTURER_GET_ERROR,
    DXP_MANUFACTURER_SELECT,
    DXP_MANUFACTURER_ADD,
    DXP_MANUFACTURER_ADD_ERROR,
    DXP_MANUFACTURER_UPDATE,
    DXP_MANUFACTURER_UPDATE_ERROR,
    DXP_MANUFACTURER_DELETE,
    DXP_MANUFACTURER_DELETE_ERROR,
} from "../actions/types";

const initialState = {
    count: null,
    featuredManufacturers: [],
    selectedManufacturer: null,
    isLoading: true,
    success: false,
};

export default function (state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case DXP_MANUFACTURER_GET:
            return {
                ...state,
                featuredManufacturers: payload,
                isLoading: false,
                success: true,
            };
        case DXP_MANUFACTURER_SELECT:
            return {
                ...state,
                selectedManufacturer: payload,
                isLoading: false,
                success: true,
            };
        case DXP_MANUFACTURER_ADD:
        case DXP_MANUFACTURER_UPDATE:
        case DXP_MANUFACTURER_DELETE:
            return {
                ...state,
                isLoading: false,
                success: true,
            };
        case DXP_MANUFACTURER_GET_ERROR:
            return {
                ...state,
                featuredManufacturers: payload,
                isLoading: false,
                success: true
            }
        case DXP_MANUFACTURER_ADD_ERROR:
        case DXP_MANUFACTURER_UPDATE_ERROR:
        case DXP_MANUFACTURER_DELETE_ERROR:
            return {
                ...state,
                isLoading: false,
                success: true
            }
        default:
            return state;
    }
}
